import React, { useEffect, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { addRSVP } from "../../utils/api";
import { useParams } from "react-router-dom";

const RSVPFrom = ({ rsvpConfigs, events }) => {
  const [forms, setForms] = useState({});
  let { pathname } = useParams();
  const [successLabel, showSuccessLabel] = useState("");

  // Example event days
  const eventDays = events?.map((event) => event?.name) || [];

  const makeFormEmpty = () => {
    const formValues = {
      name: "",
      phone: "",
      guest: "",
      attending: true,
      attendanceType: "all",
      selectedDays: [],
    };

    if (rsvpConfigs?.dateOfArrival) {
      formValues.dateOfArrival = "";
    }

    if (rsvpConfigs?.timeOfArrival) {
      formValues.timeOfArrival = "";
    }

    if (rsvpConfigs?.arrivalVenue) {
      formValues.arrivalVenue = "";
    }

    setForms(formValues);
  };

  useEffect(() => {
    makeFormEmpty();
  }, []);

  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    }),
  );

  const changeHandler = (e) => {
    setForms({
      ...forms,
      [e.target.name]: e.target.value,
    });

    if (validator.allValid()) {
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  const radioChangeHandler = (attending) => {
    setForms({
      ...forms,
      attending,
    });
  };

  // NEW: Attendance type handler
  const attendanceTypeHandler = (type) => {
    setForms({
      ...forms,
      attendanceType: type,
      selectedDays: type === "all" ? [] : forms.selectedDays,
    });
  };

  // NEW: Checkbox handler
  const daySelectionHandler = (day) => {
    let updatedDays = [...forms.selectedDays];

    if (updatedDays.includes(day)) {
      updatedDays = updatedDays.filter((d) => d !== day);
    } else {
      updatedDays.push(day);
    }

    setForms({
      ...forms,
      selectedDays: updatedDays,
    });
  };

  const onAddRSVP = async () => {
    const rsvpObj = forms;

    const body = {
      rsvpObj,
      pathname,
    };

    const response = await addRSVP(body);

    if (response?.status === 200) {
      showSuccessLabel(
        rsvpObj?.attending
          ? "We’re so happy you’ll be celebrating with us. We can’t wait to see you😊!"
          : "We’ll miss you🙁, but we’re grateful for your warm wishes❤️.",
      );

      setTimeout(() => {
        showSuccessLabel("");
      }, 5000);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (validator.allValid()) {
      onAddRSVP();
      validator.hideMessages();
      makeFormEmpty();
    } else {
      validator.showMessages();
    }
  };

  return (
    <form
      onSubmit={(e) => submitHandler(e)}
      className="contact-validation-active"
    >
      <div className="row rsvpWrapper">
        <div className="col col-lg-12 col-12">
          <div className="radio-buttons" style={{ padding: 10 }}>
            <p>
              <input
                type="radio"
                id="attend"
                name="attending"
                defaultChecked
                onChange={() => radioChangeHandler(true)}
              />
              <label htmlFor="attend">Yes, I will be there</label>
            </p>

            <p>
              <input
                type="radio"
                id="not"
                name="attending"
                onChange={() => radioChangeHandler(false)}
              />
              <label htmlFor="not">Sorry, I can’t come</label>
            </p>
          </div>
        </div>

        {/* NAME */}
        <div className="col col-lg-12 col-12">
          <div className="form-field">
            <input
              value={forms.name}
              type="text"
              name="name"
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              className="form-control"
              placeholder="Your Name"
            />

            {validator.message("name", forms.name, "required|alpha_space")}
          </div>
        </div>

        {/* PHONE */}
        <div className="col col-lg-12 col-12">
          <div className="form-field">
            <input
              value={forms.phone}
              type="text"
              name="phone"
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              className="form-control"
              placeholder="Your Contact Number"
            />

            {validator.message("phone", forms.phone, "phone")}
          </div>
        </div>

        {/* GUEST COUNT */}
        <div className="col col-lg-12 col-12">
          <div className="form-field">
            <select
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              value={forms.guest}
              className="form-control"
              name="guest"
            >
              <option>Number Of Guests</option>
              <option>01</option>
              <option>02</option>
              <option>03</option>
              <option>04</option>
              <option>05</option>
              <option>06</option>
            </select>
          </div>
        </div>

        {/* NEW RSVP SECTION */}
        {/* {forms.attending && (
          <div className="col col-lg-12 col-12">
            <div
              className="form-field"
              style={{
                padding: "15px 10px",
              }}
            >
              <label
                style={{
                  display: "block",
                  marginBottom: 12,
                  fontWeight: 600,
                }}
              >
                Which events will you attend?
              </label>

              <div className="radio-buttons">
                <p>
                  <input
                    type="radio"
                    id="all-events"
                    checked={forms.attendanceType === "all"}
                    onChange={() => attendanceTypeHandler("all")}
                  />

                  <label htmlFor="all-events">I’ll attend all events</label>
                </p>

                <p>
                  <input
                    type="radio"
                    id="partial-events"
                    checked={forms.attendanceType === "partial"}
                    onChange={() => attendanceTypeHandler("partial")}
                  />

                  <label htmlFor="partial-events">
                    I’ll attend selected events only
                  </label>
                </p>
              </div>
              {forms.attendanceType === "partial" && (
                <div
                  style={{
                    marginTop: 15,
                  }}
                >
                  {eventDays.map((day, index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <input
                        type="checkbox"
                        id={day}
                        checked={forms.selectedDays?.includes(day)}
                        onChange={() => daySelectionHandler(day)}
                      />

                      <label
                        htmlFor={day}
                        style={{
                          marginLeft: 10,
                        }}
                      >
                        {day}
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )} */}

        {/* ARRIVAL VENUE */}
        {rsvpConfigs?.arrivalVenue && (
          <div className="col col-lg-12 col-12">
            <div className="form-field">
              <select
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
                value={forms.arrivalVenue}
                className="form-control"
                name="arrivalVenue"
              >
                <option>Arrival Venue</option>

                {rsvpConfigs?.arrivalVenueOptions?.map((venue, index) => (
                  <option key={index}>{venue}</option>
                ))}
              </select>
            </div>
          </div>
        )}

        {/* ARRIVAL DATE */}
        {rsvpConfigs?.arrivalVenue && rsvpConfigs?.dateOfArrival && (
          <div className="col col-lg-12 col-12">
            <div className="form-field floating">
              <label>Arrival Date: </label>

              <input
                name="dateOfArrival"
                placeholder="Arrival Date"
                value={forms.dateOfArrival}
                type={"date"}
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
              />
            </div>
          </div>
        )}

        {/* ARRIVAL TIME */}
        {rsvpConfigs?.arrivalVenue && rsvpConfigs?.timeOfArrival && (
          <div className="col col-lg-12 col-12">
            <div className="form-field floating">
              <label>Arrival Time: </label>

              <input
                name="timeOfArrival"
                value={forms.timeOfArrival}
                placeholder="Arrival Time"
                type={"time"}
                onBlur={(e) => changeHandler(e)}
                onChange={(e) => changeHandler(e)}
              />
            </div>
          </div>
        )}
      </div>

      <div className="submit-area">
        <button type="submit" className="theme-btn">
          RSVP
        </button>
      </div>

      <p style={{ marginTop: 20, textAlign: "center" }}>{successLabel}</p>
    </form>
  );
};

export default RSVPFrom;
